var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [!_vm.activityComplete ? _c('div', {
    staticClass: "teacher-creation",
    attrs: {
      "transition": "fade"
    }
  }, [_c('text-display-list', {
    attrs: {
      "id": 'textList'
    }
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    return _c('li', {
      key: ("tc_step-" + stepIndex),
      class: ("step step-" + stepIndex)
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    })], 1);
  }), 0)], 1) : _vm._e(), _vm.showCongratsScreen ? _c('div', {
    staticClass: "congrats-screen",
    attrs: {
      "transition": "fade"
    }
  }, [_c('figure', {
    staticClass: "congrats"
  }, [_c('img', {
    attrs: {
      "src": _vm.assessmentCompletePath,
      "alt": "Group of stars to show teacher assessment completed."
    }
  })]), _c('static-intro-button', {
    attrs: {
      "enabled": _vm.enableButton,
      "on-click": _vm.handleRoundEnd
    }
  })], 1) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }